import Link from 'next/link';


export function TopBanner() {
    return (
        <div className="bg-neutral-900 text-white py-2 px-4 shadow-sm relative z-50">
            <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs sm:text-sm font-medium text-center">
                <span>
                    Launch your AI marketing agents for just $5/mo
                </span>
                <Link
                    href="/login"
                    className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded transition-colors duration-200 flex items-center gap-1 font-bold"
                >
                    Try now
                </Link>
            </div>
        </div>
    );
}
